import React, { useState } from 'react';
import { Card, Rate, Tag, Badge, Tooltip } from 'antd';
import { FireOutlined, ShoppingCartOutlined, HeartOutlined, HeartFilled } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const ProductCard = ({ id, image1, product_title, star_number, price, available }) => {
  const navigate = useNavigate();
  const [isFavorite, setIsFavorite] = useState(false);

  const handleFavoriteClick = (e) => {
    e.stopPropagation(); // empêche l'ouverture de la page produit
    setIsFavorite((prev) => !prev);
  };

  return (
    <Badge.Ribbon
      text={available ? 'Promo' : 'Disponible bientôt'}
      color={available ? 'red' : 'orange'}
    >
      <div className="product-card-wrapper" style={{ position: 'relative' }}>
        <Tooltip title={isFavorite ? 'Retirer des favoris' : 'Ajouter aux favoris'}>
          <div
            onClick={handleFavoriteClick}
            style={{
              position: 'absolute',
              top: 10,
              right: 10,
              zIndex: 10,
              fontSize: 20,
              color: isFavorite ? 'red' : '#ccc',
              cursor: 'pointer',
            }}
          >
            {isFavorite ? <HeartFilled /> : <HeartOutlined />}
          </div>
        </Tooltip>

        <Card
          hoverable
          onClick={() => navigate(`/product/${id}`)}
          style={{
            borderRadius: 12,
            overflow: 'hidden',
            boxShadow: '0 4px 16px rgba(0, 0, 0, 0.06)',
            transition: 'transform 0.3s ease',
          }}
          bodyStyle={{ padding: 16 }}
          cover={
            <div
              style={{
                overflow: 'hidden',
                borderTopLeftRadius: 12,
                borderTopRightRadius: 12,
              }}
            >
              <img
                alt={product_title}
                src={image1}
                style={{
                  height: 180,
                  width: '100%',
                  objectFit: 'cover',
                  transition: 'transform 0.3s ease',
                }}
                className="product-image"
              />
            </div>
          }
        >
          <h5>{product_title}</h5>
          <Rate disabled defaultValue={star_number} />
          <p style={{ fontWeight: 'bold', marginBottom: 8 }}>{price} XOF / Kg</p>

          <Tag color={available ? 'green' : 'red'}>
            {available ? '✅ En stock' : '❌ Rupture de stock'}
          </Tag>

          <div className='d-flex justify-content-between mt-2'>
            <Tag icon={<FireOutlined />} color='orange'>Populaire</Tag>
            <ShoppingCartOutlined style={{ fontSize: 20, color: '#1890ff', cursor: 'pointer' }} />
          </div>
        </Card>
      </div>
    </Badge.Ribbon>
  );
};

export default ProductCard;
